// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"cdbdc382","885":"75a7d02f","913":"654b13e6"}[chunkId] + ".chunk.css";
};